import { render } from "./SchoolYearSwitch.vue?vue&type=template&id=a286b116&scoped=true&ts=true"
import script from "./SchoolYearSwitch.vue?vue&type=script&lang=ts"
export * from "./SchoolYearSwitch.vue?vue&type=script&lang=ts"

import "./SchoolYearSwitch.vue?vue&type=style&index=0&id=a286b116&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a286b116"]])

export default __exports__